'use strict';

export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 60;
export const RES_PER_PAGE = 10;
export const KEY = `88d43080-69c1-4b9a-a4a0-402e39406f8f`;
export const MODAL_CLOSE_SEC = 2.5;
